import storage from '@xto10x/storage/lib';

export const ErrorMsg = {
  INVALID_EMAIL: 'Invalid email!',
  SPECIAL_CHARACTER: 'The password must contain at least one special character',
  WRONG_EMAIL: 'Your email might be wrong',
  PASSWORD_LENGTH_ERROR: 'Password should be atleast 6 characters long',
  EMPTY_NAME: 'Name cannot be empty',
  EMPTY_VERIFICATIONCODE: 'Verification Code cannot be empty',
  OBJECTIVE_MOVE_TO_KRS: "Objective can't be moved under one of its KRs.",
  OBJECTIVE_MOVE_TO_SAME_PARENT:
    "Objective can't be moved under the same parent.",
  EMPTY_EMAIL: 'Enter valid email',
  UNSAVED_CHANGES: 'You have unsaved changes.',
  SAME_OBJECTIVE_LINK_ERROR:
    'The objective has already been linked to this objective',
  OBJECTIVE_IS_IN_KRS_ERROR: "Objective can't be linked to one of its KRs.",
  OBJECTIVE_TO_LINK_IS_PARENT_ERROR: "Objective can't be linked to the parent.",
  METRIC_START_AND_TARGET_MANDATORY:
    'Start and target are mandatory for a metric.',
  NEED_METRIC_NAME: 'Need a metric name',
  DUPLICATE_METRIC:
    'A metric with the same name already exists. We recommend creating a different metric name.',
  SAME_VALUE:
    'Uh Oh! Your metrics cannot be the same, please tweak the target to the nearest decimals to proceed.',
  SAME_MILESTONE_VALUES: 'Milestone values must be unique',
  SAME_MILESTONE_DATES: 'Milestone dates must be unique',
  MILESTONE_VALUE_OUT_OF_RANGE:
    'Milestone values should lie between *start* and *target*',
  MILESTONE_DATES_OUT_OF_RANGE:
    'Milestone dates should lie between *start* and *due*',
  EMPTY_METRIC_TYPE: 'Metric type cannot be empty.',
  OBJECTIVE_DUPLICATE_ALREADY_EXISTS:
    'A copy of this objective already exists in the selected time period.',
  OBJECTIVE_OR_KR_DUPLICATE_ALREADY_EXISTS:
    "A copy of this objective or it's key results already exists selected time period.",
  OBJECTIVE_SUBTREE_DUPLICATE_ALREADY_EXISTS:
    "A copy of this objective or part of it's subtree already exists in the selected time period.",
  OBJECTIVE_SELECTED_DATE_RANGE_FALLS_OUT_OF_REVIEW_CYCLE:
    "The start date and end date doesn't fall in between the review cycle dates",
  OBJECTIVE_STARTDATE_AND_ENDDATE_CANNOT_BE_EMPTY:
    'The start date and end date cannot be empty.'
};

export const SubscribeStatus = {
  FOLLOW: 'Follow',
  UNFOLLOW: 'Unfollow'
};

export const ObjectiveActionTypes = {
  CHECK_IN: 'CHECK-IN',
  COMMENT: 'COMMENT',
  CHANGE_QUARTER: 'CHANGE_QUARTER'
};

export const PasswordLength = '6';

export const CheckInTextMaxLength = 2000;

export const MetricNameMaxLength = 60;

export const ActivityType = {
  CREATE_OBJECTIVE: 'CREATE_OBJECTIVE',
  OBJECTIVE_COMMENT: 'OBJECTIVE_COMMENT',
  OBJECTIVE_TYPE: 'OBJECTIVE_TYPE',
  OBJECTIVE_DESCRIPTION: 'OBJECTIVE_DESCRIPTION',
  OBJECTIVE_COMPLETION_STATUS: 'OBJECTIVE_COMPLETION_STATUS',
  OBJECTIVE_TITLE: 'OBJECTIVE_TITLE',
  OBJECTIVE_OKR_CYCLE: 'OBJECTIVE_OKR_CYCLE',
  OBJECTIVE_OWNER: 'OBJECTIVE_OWNER',
  OBJECTIVE_CHECK_IN: 'OBJECTIVE_CHECKIN',
  ADD_OBJECTIVE_CHECKIN: 'ADD_OBJECTIVE_CHECKIN',
  UPDATE_OBJECTIVE_CHECKIN: 'UPDATE_OBJECTIVE_CHECKIN',
  DELETE_OBJECTIVE_CHECKIN: 'DELETE_OBJECTIVE_CHECKIN',
  OBJECTIVE_PROGRESS: 'OBJECTIVE_PROGRESS',
  OBJECTIVE_STATUS: 'OBJECTIVE_STATUS',
  ADD_OBJECTIVE_TAGS: 'ADD_OBJECTIVE_TAGS', // for teams backward compatibility
  REMOVE_OBJECTIVE_TAGS: 'REMOVE_OBJECTIVE_TAGS', // for teams backward compatibility
  ADD_TAGS: 'ADD_TAGS', // for tags
  REMOVE_TAGS: 'REMOVE_TAGS', // for tags
  DELETE_TAGS: 'DELETE_TAGS', // both for teams and tags
  OBJECTIVE_PARENT_DELETED: 'OBJECTIVE_PARENT_DELETED',
  OBJECTIVE_TYPE_AFTER_PARENT_DELETION: 'OBJECTIVE_TYPE_AFTER_PARENT_DELETION',
  OBJECTIVE_KEY_RESULT_DELETED: 'OBJECTIVE_KEY_RESULT_DELETED',
  ALIGN_OBJECTIVE: 'ALIGN_OBJECTIVE',
  OBJECTIVE_DUE_DATE: 'OBJECTIVE_DUE_DATE',
  OBJECTIVE_START_DATE: 'OBJECTIVE_START_DATE',
  OBJECTIVE_CREATION_BY_DUPLICATION: 'OBJECTIVE_CREATION_BY_DUPLICATION',
  OBJECTIVE_DUPLICATION: 'OBJECTIVE_DUPLICATION',
  ADD_METRIC: 'ADD_METRIC',
  UPDATE_METRIC: 'UPDATE_METRIC',
  DELETE_METRIC: 'DELETE_METRIC',
  ADD_MILESTONE: 'ADD_MILESTONE',
  UPDATE_MILESTONE: 'UPDATE_MILESTONE',
  DELETE_MILESTONE: 'DELETE_MILESTONE',
  OBJECTIVE_VISIBILITY_UPDATE: 'OBJECTIVE_VISIBILITY_UPDATE',
  ADD_PROGRESS_TRACKER: 'ADD_PROGRESS_TRACKER',
  UPDATE_PROGRESS_TRACKER: 'UPDATE_PROGRESS_TRACKER',
  DELETE_PROGRESS_TRACKER: 'DELETE_PROGRESS_TRACKER',
  MANAGER_APPROVAL_STATUS_UPDATE: 'MANAGER_APPROVAL_STATUS_UPDATE',
  REQUEST_FOR_MANAGER_APPROVAL: 'REQUEST_FOR_MANAGER_APPROVAL',
  UPDATE_WEIGHTAGE: 'UPDATE_WEIGHTAGE',
  UPDATE_BUSINESS_ALIGNMENT: 'UPDATE_BUSINESS_ALIGNMENT',
  ADD_CONTRIBUTORS: 'ADD_CONTRIBUTORS',
  REMOVE_CONTRIBUTORS: 'REMOVE_CONTRIBUTORS',
  OBJECTIVE_GOAL_SCOPE: 'OBJECTIVE_GOAL_SCOPE',
  OBJECTIVE_GROWTH_AREAS: 'OBJECTIVE_GROWTH_AREAS',
  OBJECTIVE_GROWTH_SUPPORT_AREAS: 'OBJECTIVE_GROWTH_SUPPORT_AREAS',
  AUTO_ROLLUP_KRS_UPDATED: 'AUTO_ROLLUP_KRS_UPDATED',
  AUTO_ROLLUP_TURNED_ON: 'AUTO_ROLLUP_TURNED_ON',
  AUTO_ROLLUP_TURNED_OFF: 'AUTO_ROLLUP_TURNED_OFF',
  AUTO_ROLLUP_TYPE_CHANGED: 'AUTO_ROLLUP_TYPE_CHANGED',
  AUTO_ROLLUP_WEIGHTAGE_CHANGED: 'AUTO_ROLLUP_WEIGHTAGE_CHANGED',
  AUTO_ROLLUP_TRIGGERED_DUE_TO_USER_ACTION:
    'AUTO_ROLLUP_TRIGGERED_DUE_TO_USER_ACTION',
  AUTO_ROLLUP_TURNED_OFF_BY_SYSTEM: 'AUTO_ROLLUP_TURNED_OFF_BY_SYSTEM',
  AUTO_ROLLUP_KR_DELETED_FROM_ATTRIBUTES:
    'AUTO_ROLLUP_KR_DELETED_FROM_ATTRIBUTES'
};

export const ActivityTypeValue = {
  NEEDS_WORK: 'Needs Work',
  NOT_STARTED: 'Not Started',
  NEGOTIATION: 'Negotiation',
  OFF_TRACK: 'Off Track',
  REJECTED: 'rejected',
  ACCEPTED: 'Accepted',
  ON_TRACK: 'On Track',
  ACHIEVED: 'Achieved 🎉',
  DROPPED: 'Dropped',
  COMPANY: 'Company Objective',
  INDEPENDENT: 'Independent',
  NOT_ACHIEVED: 'Not Achieved',
  ADD_METRIC: 'ADD_METRIC',
  UPDATE_METRIC: 'UPDATE_METRIC'
};

export const ObjectiveCycleStatus = {
  EXPIRED: 'EXPIRED',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
};

export const UserStatus = {
  REVOKED: 'REVOKED',
  INVALID: 'INVALID',
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING'
};

export const UserRole = {
  ADMIN: 'ADMIN',
  USER: 'USER',
  SUPER_HR: 'SUPER_HR',
  SUPER_ADMIN: 'SUPER_ADMIN',
  GOALS_ADMIN: 'GOALS_ADMIN',
  ADMIN_AND_LEADER: 'ADMIN_AND_LEADER'
};

export const UserRolesWithLabels = [
  // {
  //   label: 'Super HR',
  //   id: UserRole.SUPER_HR
  // },
  {
    label: 'Admin',
    id: UserRole.ADMIN
  },
  {
    label: 'User',
    id: UserRole.USER
  }
];

export const ActionKey = {
  ADMIN: 'ADMIN',
  USER: 'USER'
};

export const StorageKey = {
  ORG_INFO: 'ORG_INFO',
  USER_INFO: 'USER_INFO',
  PRODUCT_ID: 'PRODUCT_ID',
  GOOGLE_ACCESS_TOKEN: 'GOOGLE_ACCESS_TOKEN',
  COGNITO_ACCESS_TOKEN: 'COGNITO_ACCESS_TOKEN',
  REQUESTER_USER_ID: 'REQUESTER_USER_ID',
  SIGN_IN_MODE: 'SIGN_IN_MODE',
  IS_GOOGLED_SIGNED: 'IS_GOOGLED_SIGNED', // can we removed later
  USER_ORGS: 'USER_ORGS',
  REDIRECT_URL: 'REDIRECT_URL',
  ORG_SETTINGS: 'ORG_SETTINGS',
  IS_PEOPLE_CUES_ORG: 'IS_PEOPLE_CUES_ORG',
  REVIEW_LAST_PAGE: 'REVIEW_LAST_PAGE',
  RECENT_CREATE_OBJ_SELECTIONS: 'RECENT_CREATE_OBJ_SELECTIONS',
  GOALS_STRENGTH_SCHEMA: 'GOALS_STRENGTH_SCHEMA',
  FEATURE_PANEL_CONFIG: 'FEATURE_PANEL_CONFIG',
  HTTP_CLIENT_CONFIG: 'HTTP_CLIENT_CONFIG',
  PREVIOUS_SELECTED_CUSTOM_RANGE: 'PREVIOUS_SELECTED_CUSTOM_RANGE',
  ALL_USER_PREFERENCES: 'ALL_USER_PREFERENCES',
  CUSTOM_RANGE_VIEW_PRESET: 'CUSTOM_RANGE_VIEW_PRESET',
  IS_ORG_SYNC_NEEDED: 'IS_ORG_SYNC_NEEDED',
  REVIEW_DRAFT_DATA: 'REVIEW_DRAFT_DATA'
  // CREATE_OBJECTIVE_LIST_OF_KRS: 'CREATE_OBJECTIVE_LIST_OF_KRS'
};

export const ObjectiveStatus = {
  NEEDS_WORK: 'NEEDS_WORK',
  NOT_STARTED: 'NOT_STARTED',
  NEGOTIATION: 'NEGOTIATION',
  OFF_TRACK: 'OFF_TRACK',
  REJECTED: 'REJECTED',
  ACCEPTED: 'ACCEPTED',
  ON_TRACK: 'ON_TRACK',
  ACHIEVED: 'ACHIEVED',
  DROPPED: 'DROPPED',
  COMPANY: 'COMPANY',
  INDEPENDENT: 'INDEPENDENT',
  NOT_ACHIEVED: 'NOT_ACHIEVED'
};

export const FilterStatusTypes = [
  {
    name: 'Not Started',
    id: ObjectiveStatus.NOT_STARTED
  },
  {
    name: 'Off Track',
    id: ObjectiveStatus.OFF_TRACK
  },
  {
    name: 'Needs Work',
    id: ObjectiveStatus.NEEDS_WORK
  },
  {
    name: 'On Track',
    id: ObjectiveStatus.ON_TRACK
  },
  {
    name: 'Dropped',
    id: ObjectiveStatus.DROPPED
  },
  {
    name: 'Achieved 🎉',
    id: ObjectiveStatus.ACHIEVED
  },
  {
    name: 'Not Achieved',
    id: ObjectiveStatus.NOT_ACHIEVED
  }
];

export const FilterObjectiveTypes = [
  {
    name: 'Company objectives',
    id: 'COMPANY'
  },
  {
    name: 'Independent objectives',
    id: 'INDEPENDENT'
  }
];

export const FilterLabelTypes = [
  {
    // heading: 'Starred Objectives',
    name: 'Show all starred objectives',
    label: 'Starred', // used in filter chips
    id: '1bf296d3-153e-4cd9-96fc-e26b29d29565'
  }
];

export const PendingManagerApprovalTypes = [
  {
    heading: 'Pending manager approval objectives',
    name: 'Show all pending manager approval objectives',
    label: 'Pending', // used in filter chips
    id: 'PENDING'
  },
  {
    heading: 'Rejected manager approval objectives',
    name: 'Show all rejected manager approval objectives',
    label: 'Rejected', // used in filter chips
    id: 'DENIED'
  }
];

export const FilterNegotiationStatus = [
  {
    name: 'Accepted State',
    label: 'Accepted',
    id: 'ACCEPTED'
  },
  {
    name: 'Negotiation State',
    label: 'In negotiation',
    id: 'NEGOTIATION'
  },
  {
    name: 'Declined State',
    label: 'Declined',
    id: 'REJECTED'
  }
];

export const FilterLevels = [0, 1, 2, 3, 4, 5, 6, 7, 8];

export const QueryParam = {
  OBJECTIVE_CYCLE: 'oc',
  SELECTED_TEAM: 'tm',
  SELECTED_OBJECTIVE: 'ob',
  OBJECTIVE_TYPE: 'ot',
  OBJECTIVE_LEVEL: 'ol',
  USER_ID: 'user',
  OBJECTIVE_FILTER_TYPE: 'oft',
  OBJECTIVE_STATUS_TYPE: 'ost',
  LINK_SOURCE: 'ls',
  VIEW_IN_CONTEXT: 'vc',
  FILTERS: 'filters',
  TREE_TRAVERSE_DEPTH: 'depth',
  CUSTOM_DATE_RANGE_START_DATE: 'csd',
  CUSTOM_DATE_RANGE_END_DATE: 'ced',
  DEPARTMENT: 'dp',
  USER_PERSONA: 'up'
};

export const ToastActionText = {
  REFRESH: 'Refresh',
  VIEW: 'View',
  UNDO: 'Undo'
};

export const ToastActionType = {
  HIGHLIGHT_OBJECTIVE: 'HIGHLIGHT_OBJECTIVE',
  REFRESH_PAGE: 'REFRESH_PAGE',
  REFRESH_OBJECTIVES: 'REFRESH_OBJECTIVES',
  VIEW_OBJECTIVE_DETAILS: 'VIEW_OBJECTIVE_DETAILS',
  LINK: 'LINK',
  CLEAR_LEVEL_FILTER: 'CLEAR_LEVEL_FILTER',
  UPDATE_WITH_NEW_VERSION: 'UPDATE_WITH_NEW_VERSION',
  UNDO_DND_ACTION: 'UNDO_DND_ACTION',
  API_CALL_NETWORK_ERROR_FAILURE: 'API_CALL_NETWORK_ERROR_FAILURE',
  GO_BACK: 'GO_BACK',
  OPEN_KR_DETAILS: 'OPEN_KR_DETAILS',
  OKR_HEIRARCHY_UPDATED: 'OKR_HEIRARCHY_UPDATED',
  CUSTOM_CALLBACK: 'CUSTOM_CALLBACK',
  ORG_HIERARCHY_ERROR: 'ORG_HIERARCHY_ERROR',
  OKR_ADMIN_IS_BASIC_USER: 'OKR_ADMIN_IS_BASIC_USER'
};

export const HeaderLeftTabs = [
  {
    label: 'My Objectives',
    tag_id: '8b97e974-13c6-4c71-b225-6c9d52ac3100'
  },
  /* {
    label: 'My Starred',
    tag_id: '1bf296d3-153e-4cd9-96fc-e26b29d29565'
  }, */
  {
    label: 'My Directs',
    tag_id: '95f5bc8d-b366-4bbd-b441-773af5e3696a'
  },
  {
    label: 'All Objectives',
    mobile_label: 'All',
    tag_id: '0c5ac74d-394f-420f-8932-5d10a71d9a78'
  }
];

export const ObjCycleGoalsSpaceTabs = [
  {
    tag_id: 'tab1',
    label: 'Time Period'
  },
  {
    tag_id: 'tab2',
    label: 'Annual Goals'
  }
];

export const ObjectiveActions = [
  {
    text: 'View Details',
    type: 'text',
    id: 'view'
  },
  {
    text: 'Copy to Time Period',
    type: 'dropDown',
    id: 'copyToQuarter'
  },
  {
    text: 'Paste here as key result',
    type: 'text',
    id: 'paste'
  },
  {
    text: 'Move Objective',
    type: 'text',
    id: 'move'
  },
  {
    text: 'Visibility',
    type: 'text',
    id: 'visibility'
  },
  {
    text: 'Add Key Result',
    type: 'text',
    id: 'add_key_result'
  },
  {
    text: 'Link to Objective',
    type: 'text',
    id: 'link',
    isSectionBreakerRequired: true
  },
  {
    text: 'Link here as key result',
    type: 'text',
    id: 'link-here'
  },
  {
    text: 'View Alignment to annual',
    type: 'text',
    id: 'view-strategic-link'
  },
  {
    text: 'Delete',
    type: 'text',
    id: 'delete',
    color: '#df2e2e',
    isSectionBreakerRequired: true
  }
];

export const TagActions = [
  { text: 'Manage your tags', type: 'text', id: 'manage_tags' }
];

export const LinkedObjectiveActions = [
  // disabled this for now as implementation is not done
  // {
  //   text: 'Go to original',
  //   type: 'text',
  //   id: 'goToOriginal'
  // },

  // not needed in the linked objectives for now
  // {
  //   text: 'View Linked Objectives',
  //   type: 'text',
  //   id: 'viewLinkedObjectives'
  // },
  {
    text: 'View Details',
    type: 'text',
    id: 'view'
  },
  {
    text: 'Comment',
    type: 'text',
    id: 'comment'
  },
  {
    text: 'Move',
    type: 'text',
    id: 'move'
  },
  {
    text: 'Unlink',
    type: 'text',
    id: 'unlink'
  }
];

export const IDPObjectiveDetailViewActions = [
  {
    text: 'Edit',
    type: 'text',
    id: 'edit'
  },
  {
    text: 'Drop',
    type: 'text',
    id: 'drop'
  }
];

export const ObjectiveDetailViewActions = [
  {
    text: 'Edit',
    type: 'text',
    id: 'edit'
  },
  {
    text: 'Copy to Time Period',
    type: 'dropDown',
    id: 'copyToQuarter'
  },
  {
    text: 'Move Objective',
    type: 'text',
    id: 'move',
    disableText:
      'Objective can be moved only when viewed within the same time period. Please change your time period to move the objective.'
  },
  {
    text: 'Visibility',
    type: 'text',
    id: 'visibility'
  },
  {
    text: 'Link to Objective',
    type: 'text',
    id: 'link',
    isSectionBreakerRequired: true
  },
  {
    text: 'Track Progress with JIRA',
    type: 'text',
    id: 'track_with_jira'
  },
  {
    text: 'Edit JIRA Integration',
    type: 'text',
    id: 'edit_jira_integration'
  },
  {
    text: 'Remove GSheets Automation',
    type: 'text',
    id: 'unlink_google_sheets'
  },

  {
    text: 'View Objective Strength',
    type: 'text',
    id: 'view_okr_strength'
  },
  {
    text: 'Delete',
    type: 'text',
    id: 'delete',
    color: '#df2e2e'
  }
];

export const copyToQuarterOptions = [
  {
    text: 'Copy this objective only',
    id: 0
  },
  {
    text: 'Copy objective and its key results',
    id: 1
  },
  {
    text: 'Copy objective and entire key result tree',
    id: -1
  }
];

export const ActiveMemberAdminActions = [
  {
    text: 'Make Workspace Administrator',
    type: 'text',
    id: 'change_role'
  },
  {
    text: 'Remove User',
    type: 'text',
    id: 'delete_user'
  }
];

export const RemoveAdminUserActions = [
  {
    text: 'Remove Administrator Rights',
    type: 'text',
    id: 'change_role'
  },
  {
    text: 'Remove User',
    type: 'text',
    id: 'delete_user'
  }
];

export const PendingMemberAdminActions = [
  {
    text: 'Make Administrator',
    type: 'text',
    id: 'change_role'
  },
  {
    text: 'Reinvite',
    type: 'text',
    id: 'reinvite'
  },
  {
    text: 'Revoke Invitation',
    type: 'text',
    id: 'revoke_invitation'
  }
];

export const PendingMemberRemoveAdminUserActions = [
  {
    text: 'Remove Administrator Rights',
    type: 'text',
    id: 'change_role'
  },
  {
    text: 'Reinvite',
    type: 'text',
    id: 'reinvite'
  },
  {
    text: 'Revoke Invitation',
    type: 'text',
    id: 'revoke_invitation'
  }
];

export const DateConversionType = {
  HOUR_AND_DATE: 'HOUR_AND_DATE',
  TIME_AGO: 'TIME_AGO',
  DATE_AND_YEAR: 'DATE_AND_YEAR'
};

export const ObjectiveDescPlaceholder =
  'Add links to working documents like dashboards, google sheets or JIRA tickets.';

export const wordLimit = {
  ZERO: 'ZERO',
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  FULL: 'FULL',
  OVER: 'OVER'
};

export const exportCsvHeaders = {
  IS_ALIGNED_TO: 'Is/Aligned to',
  TITLE: 'Title',
  PARENT_OBJECTIVE_TITLE: 'Parent Objective Title',
  METRIC: 'Metric',
  STATE: 'State',
  OWNER: 'Owner',
  OWNER_EMAIL: 'Owner Email',
  TEAMS: 'Teams',
  TAGS: 'Tags',
  METRIC_NAME: 'Metric Name',
  START_VALUE: 'Start Value',
  TARGET_VALUE: 'Target Value',
  CURRENT_VALUE: 'Current Value',
  MILESTONE_DATE: 'Milestone $value$ Date',
  MILESTONE_VALUE: 'Milestone $value$ Value',
  PROGRESS: 'Progress %',
  STATUS: 'Status',
  OBJECTIVE_ID: 'Objective Id',
  PARENT_OBJECTIVE_ID: 'Parent Objective Id',
  START_DATE: 'Start Date',
  DUE_DATE: 'Due Date',
  LAST_UPDATED_TIME: 'Last Check-in Time',
  LAST_CHECK_IN: 'Last Check In',
  MANAGER_APPROVAL_STATUS: 'Manager Approval Status'
};

export const ManagerApprovalTypes = {
  AUTO_APPROVED: 'Auto Approved',
  PENDING: 'Pending',
  APPROVED: 'Approved',
  DENIED: 'Rejected'
};

export const exportUserboardCSVHeaders = {
  USER_NAME: 'User Name',
  USER_EMAIL: 'User Email',
  OKRS_OWNED: 'OKRS owned',
  OKRS_IN_NEGOTIATION: 'Objectives awaiting acceptance',
  OKRS_AWAITING_UPDATES: 'Objectives awaiting check-ins',
  OKRS_PENDING_MANAGER_APPROVAL: 'Objectives pending manager approval',
  AVERAGE_PROGRESS: 'Average progress',
  NOT_STARTED: 'Not Started',
  OFF_TRACK: 'Off Track',
  NEEDS_WORK: 'Needs Work',
  ON_TRACK: 'On Track',
  DROPPED: 'Dropped',
  ACHIEVED: 'Achieved',
  NOT_ACHIEVED: 'Not Achieved',
  PENDING_MANAGER_APPROVAL: 'Pending Manager Approval'
};

export const AlertActionTypes = {
  SUCCESS: 'success',
  LOADING: 'loading',
  FIXED: 'fixed',
  ALERT: 'alert',
  ERROR: 'error',
  VIEW_UPDATED: 'view_updated',
  NO_ICON: 'no_icon'
};

export const FirebaseKeys = {
  api_error_code_mapping: 'api_error_code_mapping',
  app_insight_dashboard: 'app_insight_dashboard',
  feature_config: 'feature_config',
  integrations: {
    slack: 'slack_integration',
    jira: 'jira_integration',
    'google sheets': 'google_sheets_integration',
    'microsoft teams': 'microsoft_teams_integration'
  },
  autopopulate_email_jira_create_conn: 'autopopulate_email_jira_create_conn',
  add_kr_in_previous_quarter: 'add_kr_in_previous_quarter',
  level_filter: 'level_filter',
  sheets_integration_status_card: 'sheets_integration_status_card',
  lock_edits: 'lock_edits',
  feedback_module_integration: 'feedback_module_integration',
  review_module_integration: 'review_module_integration',
  ama_module_integration: 'ama_module_integration',
  show_feedback_new_tag: 'show_feedback_new_tag',
  show_review_beta_tag: 'show_review_beta_tag',
  inviteVideoEmbedLink: 'inviteVideoEmbedLink',
  filter_categories: 'filter_categories',
  disable_upload_hierarchy: 'disable_upload_hierarchy',
  rating_label: 'review_rating_label',
  objective_bulk_upload: 'objective_bulk_upload',
  show_org_hierarchy_to_all: 'show_org_hierarchy_to_all',
  hrbp: 'hrbp',
  hris_integration: 'hris_integration',
  in_app_reporting: 'in_app_reporting',
  no_limit_checkin_progress: 'no_limit_checkin_progress',
  objective_suggestion_AI: 'objective_suggestion_AI',
  in_app_reporting_options_config: 'in_app_reporting_options_config',
  disable_checkin_on_pending_approval: 'disable_checkin_on_pending_approval',
  disable_non_admin_access_of_exports: 'disable_non_admin_access_of_exports',
  continuousSurveyDefaultDateRange: 'continuousSurveyDefaultDateRange',
  disable_rating_color: 'disable_rating_color',
  auto_roll_up: 'auto_roll_up',
  metric_mandatory: 'metric_mandatory',
  disable_user_board_for_users: 'disable_user_board_for_users'
};

export const DEFAULT_RATING = {
  BG_COLOR: '#2f53d7',
  LIGHT_BG_COLOR: '#e5f1ff',
  LIGHT_TEXT_COLOR: '#2f53d7',
  TEXT_COLOR: '#ffffff',
  BORDER_COLOR: '#2f53d7'
};

export const HelpDropDownLinks = [
  {
    label: 'Getting Started',
    link: 'https://docs.xto10x.com/peoplecues',
    id: 'getting_started'
  },
  {
    label: 'OKR Playbook',
    link: 'https://docs.xto10x.com/peoplecues/objectives/okr-process-guides',
    id: 'okr_playbook'
  }
];

export const AuthenticatedUserPaths = [
  '/orgs',
  '/objectives',
  '/dashboard',
  '/profile',
  '/jira',
  '/userboard',
  'token',
  '/okr-reports'
];

export const UnAuthenticatedUserPaths = [
  '/login',
  '/forgot-password',
  '/sign-up',
  '/reset-password',
  '/sign-up-invite',
  '/signin',
  '/'
];

export const UrlOrgDomainExceptions = [
  'login',
  'forgot-password',
  'sign-up',
  'signup',
  'reset-password',
  'sign-up-invite',
  'signin'
];

export const SidebarVisibilityPaths = [
  '/objectives',
  '/dashboard',
  '/profile',
  '/jira',
  '/userboard',
  '/token',
  '/settings',
  '/one-on-one',
  '/okr-reports',
  '/growth',
  'home'
];
export const SidebarInvisibilityPaths = [
  '/surveys/survey/',
  '/surveys/say-hello',
  '/surveys/responses'
];

export const CuesHeaderInvisibilityPaths = [
  '/surveys/survey/',
  '/surveys/surveymanagement/configure/',
  '/surveys/surveymanagement/details/',
  '/surveys/report',
  '/surveys/say-hello',
  '/surveys/responses',
  '/surveys/action-plan/questions',
  '/surveys/action-plan/view'
];

export const DeepLinkPaths = {
  FEEDBACK: 'feedback',
  REVIEW: 'review',
  SETTINGS: 'settings',
  PROFILE: 'profile',
  SURVEYS: 'surveys',
  AMA: 'ama',
  ONE_ON_ONE: 'one-on-one',
  GROWTH: 'growth'
};

export const NotificationPreferenceTypes = [
  {
    id: 'OBJECTIVE_CORE_ACTIVITY',
    text: 'Creating, editing & deleting objectives'
  },
  { id: 'MENTIONS', text: 'Direct mentions & comments' },
  { id: 'ACKNOWLEDGEMENTS', text: 'Acknowledgement of Accept/Decline' },
  { id: 'OBJECTIVE_UPDATES', text: 'Updates on objectives & key results' },
  {
    id: 'OBJECTIVE_OTHERS',
    text: 'Others'
  }
];

export const KeyCodes = {
  escape: 27,
  enter: 13,
  space: 32,
  arrowDown: 40,
  arrowUp: 38
};

export const FeatureInfoMapping = {
  LINK_OBJECTIVE: {
    img: 'link-info-img',
    heading: 'Linking to an objective',
    description:
      'Linking is easy - You’ve already picked the objective you want to link. Now find the objective you want to link to and click on “Link here as key result” from the 3-dot menu.',
    externalLink:
      'https://docs.xto10x.com/getting-started-on-10xgoals/multiple-alignment/'
  },
  MOVE_OBJECTIVE: {
    img: 'move-info-img',
    heading: '🎉 Ready to Move Objective',
    description:
      'Moving an objective is easy - You’ve already picked the objective you want to move. Now find the objective you want to move in to and click on “Paste here as key result” from the 3-dot menu.',
    externalLink:
      'https://docs.xto10x.com/getting-started-on-10xgoals/restructure-okrs/'
  }
};

export const UserTaskStatus = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED'
};

export const DisabledTextObjectiveActions = {
  MOVE_IN_PROGRESS: 'Move is in progress',
  LINK_IN_PROGRESS: 'Linking is in progress'
};

export const TaskPanelInfoText = {
  EMPTY_TASKS_TEXT:
    'You can assign action item to anyone by mentioning them in a comment.',
  EMPTY_OPEN_TASK_ASSIGNED_BY_USER_TEXT:
    'None of the action items assigned by you are in open state',
  EMPTY_CLOSED_TASK_ASSIGNED_BY_USER_TEXT:
    'None of the action items assigned by you are in closed state',
  EMPTY_OPEN_TASK_ASSIGNED_TO_USER_TEXT:
    'No open actions items are currently assigned to you',
  EMPTY_CLOSED_TASK_ASSIGNED_TO_USER_TEXT:
    'No closed action items are currently under you',
  LEARN_MORE_LINK: 'https://docs.xto10x.com/peoplecues/objectives/action-feed'
};

export const AccountLeftTabs = {
  Profile: {
    text: 'Profile',
    id: 'profile'
  }
};

export const HeaderMenus = [
  {
    path: 'profile',
    text: 'Account',
    icon: 'person'
  }
];

export const ViewDashboardConfig = {
  BY_OBJECTIVE_NEGOTIATION_STATE: {
    actionType: 'objective-state',
    okrGraphTitle: 'Objectives awaiting acceptance',
    customRangeGraphTitle: 'Objectives awaiting acceptance',
    filterMapping: 'negotiation_states'
  },
  // BY_OBJECTIVE_OVERDUE_WITH_LEVELS: {
  //   actionType: 'objective-overdue-with-levels',
  //   okrGraphTitle: 'objective-overdue-with-levels',
  //   customRangeGraphTitle: 'objective-overdue-with-levels',
  //   filterMapping: 'due_date'
  // },
  BY_OBJECTIVE_ALIGNMENT_TYPE: {
    actionType: 'objective-count-by-type',
    okrGraphTitle: 'Objectives aligned to company',
    customRangeGraphTitle: 'Objectives aligned to company',
    filterMapping: 'objectives'
  },
  BY_OBJECTIVE_LAST_UPDATED_TIME: {
    actionType: 'objective-last-updated-details',
    okrGraphTitle: () =>
      `Objectives not checked in ${
        storage.getDataFromLocal(StorageKey.ORG_SETTINGS)
          ?.objectives_not_updated_from_days || 15
      } days`,
    customRangeGraphTitle: () =>
      `Objectives not checked in ${
        storage.getDataFromLocal(StorageKey.ORG_SETTINGS)
          ?.objectives_not_updated_from_days || 15
      } days`,
    filterMapping: 'objectives_not_updated_from_days'
  },
  BY_OBJECTIVE_COMPLETION_STATE: {
    actionType: 'objective-completion-state',
    okrGraphTitle: 'Objectives by Status',
    customRangeGraphTitle: 'Objectives by Status',
    filterMapping: 'status'
  },
  BY_OBJECTIVE_PERCENTAGE_PROGRESS_STATE: {
    actionType: 'objective-progress-buckets',
    okrGraphTitle: 'Objectives by Progress',
    customRangeGraphTitle: 'Objectives by Progress',
    filterMapping: 'progress_percentage'
  },
  PENDING_MANAGER_APPROVAL: {
    actionType: 'objective-manager-approval-status',
    okrGraphTitle: 'Objectives Pending manager approval',
    customRangeGraphTitle: 'Objectives Pending manager approval',
    filterMapping: 'manager_approval_status'
  }
};

export const UserBoardKeyMapping = {
  okrs_in_negotiation: 'Awaiting Acceptance',
  okrs_awaiting_updates: () =>
    `Objectives not checked in ${
      storage.getDataFromLocal(StorageKey.ORG_SETTINGS)
        ?.objectives_not_updated_from_days || 15
    } days`,
  okrs_owned: 'Owned',
  pending_manager_approval: 'Pending manager approval'
};

export const ViewDashboardCircularProgressColorMapping = {
  BY_OBJECTIVE_ALIGNMENT_TYPE: [
    { from: 86, to: 100, color: '#1db510' },
    { from: 65, to: 85, color: '#f9b312' },
    { from: 0, to: 64, color: '#eb5757' }
  ],
  BY_OBJECTIVE_NEGOTIATION_STATE: [
    { from: 0, to: 10, color: '#1db510' },
    { from: 11, to: 30, color: '#f9b312' },
    { from: 31, to: 100, color: '#eb5757' }
  ],
  BY_OBJECTIVE_LAST_UPDATED_TIME: [
    { from: 0, to: 10, color: '#1db510' },
    { from: 11, to: 30, color: '#f9b312' },
    { from: 31, to: 100, color: '#eb5757' }
  ]
};

export const FilterOptions = [
  {
    name: 'Due Date',
    id: 'due_date'
  },
  {
    name: 'Not checked-in since',
    id: 'not_checked'
  },
  {
    name: 'Levels',
    id: 'levels'
  },
  {
    name: 'Status',
    id: 'status'
  },
  {
    name: 'Progress',
    id: 'progress'
  },
  {
    name: 'Teams',
    id: 'teams'
  },
  {
    name: 'Tags',
    id: 'tags'
  },
  {
    name: 'Owners',
    id: 'owners'
  },
  {
    name: 'Negotiation State',
    id: 'negotiation_state'
  },
  {
    name: 'Starred Objectives',
    id: 'personal'
  }
];

export const FilterParams = [
  'owners',
  'teams',
  'tags',
  'status',
  'objective_type',
  'due_date',
  'label_ids',
  'negotiation_states',
  'objective_status',
  'progress_higher_than',
  'progress_lower_than',
  'objectives_not_updated_from_days',
  'exclude_if_due_date_passed',
  'level',
  'contributor_filter'
];

export const ObjectiveStatusTypes = [
  'NOT_STARTED',
  'OFF_TRACK',
  'ON_TRACK',
  'DROPPED',
  'NEEDS_WORK',
  'ACHIEVED',
  'NOT_ACHIEVED'
];

export const ObjectiveNegotiationStates = [
  'ACCEPTED',
  'NEGOTIATION',
  'REJECTED'
];

export const SidebarDropDowns = {
  NOTIFICATION: 'NOTIFICATION',
  USER_ACCOUNT: 'USER_ACCOUNT',
  TASK_BOARD: 'TASK_BOARD',
  FEATURE_PANEL: 'FEATURE_PANEL'
  // TODO : Add for HELP dropdown too
};

export const SendRemindersFilterTypes = [
  'objectives_not_updated_from_days',
  'negotiation_states',
  'progress_higher_than',
  'status',
  'objectives',
  'manager_approval_status'
];

export const SendReminderTypes = {
  okrs_awaiting_updates: 'AWAITING_CHECK_INS',
  okrs_in_negotiation: 'AWAITING_ACCEPTANCE',
  okrs_owned: 'OKRS_OWNED',
  objective_completion_status_count_map: 'STATUS',
  objectives_not_updated_from_days: 'AWAITING_CHECK_INS',
  negotiation_states: 'AWAITING_ACCEPTANCE',
  status: 'STATUS',
  pending_manager_approval: 'MANAGER_APPROVAL_PENDING'
};

// Reminder type constants
export const ReminderTypes = {
  AWAITING_ACCEPTANCE: 'AWAITING_ACCEPTANCE',
  AWAITING_CHECK_INS: 'AWAITING_CHECK_INS',
  PENDING_OBJECTIVE_CREATION: 'PENDING_OBJECTIVE_CREATION'
};

// Negotiation state constants
export const NegotiationStates = {
  NEGOTIATION: 'NEGOTIATION'
};

export const ViewDashboardCircularProgressColors = [
  '#eb5757',
  '#f9b312',
  '##95a3fb',
  '#1db510'
];

export const ExternalLinks = {
  NO_OBJECTIVE_STARRED_EXTERNAL_LINK:
    'https://docs.xto10x.com/peoplecues/objectives/starring-objectives',
  PRIVACY_POLICY: 'https://www.xto10x.com/privacy-policy',
  AUTO_ROLL_UP_DOC:
    'https://docs.xto10x.com/peoplecues/objectives/check-ins-and-comments/automating-check-ins/auto-roll-up/configuring-auto-roll-up',
  ACCESS_CONTROL_MANAGEMENT:
    'https://docs.xto10x.com/peoplecues/objectives/access-management-in-objectives'
};

export const EMOJIS_PALETTE_OPTIONS = {
  emojis_data: {
    '\uD83D\uDC4F': {
      enabled: true,
      id: '2f26f82b-fbcb-11ea-bdd5-0215b6e3dd02'
    },
    '\uD83D\uDE4C': {
      enabled: true,
      id: '9ae29f3b-fbcb-11ea-bdd5-0215b6e3dd02'
    },
    '\uD83D\uDE4F': {
      enabled: true,
      id: '11587024-fbcc-11ea-bdd5-0215b6e3dd02'
    },
    '\uD83D\uDC4D': {
      enabled: true,
      id: '115d1b66-fbcc-11ea-bdd5-0215b6e3dd02'
    },
    '\uD83D\uDE80': {
      enabled: true,
      id: '11613a08-fbcc-11ea-bdd5-0215b6e3dd02'
    },
    '\uD83D\uDD25': {
      enabled: true,
      id: '1165560c-fbcc-11ea-bdd5-0215b6e3dd02'
    },
    '\uD83C\uDF89': {
      enabled: true,
      id: '1169bc22-fbcc-11ea-bdd5-0215b6e3dd02'
    }
  }
};

export const defaultLevelFilterConfig = [
  {
    value: 0,
    enabled: true
  },
  {
    value: 1,
    enabled: true
  },
  {
    value: 2,
    enabled: true
  }
];

export const APPLICATION_CHANNELS = {
  desktop: 'WEBSITE',
  mobile: 'MOBILE_WEB'
};

export const IntegrationChannelLabelMap = {
  GOOGLE_SHEETS: 'Google Sheets',
  JIRA: 'Jira'
};

export const UserConfigType = {
  JIRA_PROMPT: 'jira_prompt',
  SUMMARY_DASHBOARD_PREFERENCE: 'summary_dashboard_preference',
  MOVE_OBJECTIVE: 'move_objective_info_viewed',
  LINK_OBJECTIVE: 'link_objective_info_viewed',
  FEATURE_PANEL_USER_ACTIONS_DATA: 'feature_panel_user_actions_data',
  QUICK_TIPS: 'quick_tips',
  SAMPLE_OKRS: 'sample_okrs',
  SEEN_TEAM_REVIEW_USAGE_POPUP: 'seen_team_review_usage_popup',
  TEAMS_QUICK_FILTERS: 'teams_quick_filters',
  HIDE_OBJECTIVE_STRENGTH_IN_DETAIL: 'hide_objective_strength_in_detail',
  SEEN_CLOVER_INTRO_MODAL: 'seen_clover_intro_modal',
  SEEN_CLOVER_INTRO_STEPS: 'seen_clover_intro_steps',
  HIDE_BULK_APPROVAL_ALL_OBJECTIVES_POPUP:
    'hide_bulk_approval_all_objectives_popup',
  HIDE_BULK_APPROVAL_OKR_AND_KRS_POPUP: 'hide_bulk_approval_okr_and_krs_popup',
  HIDE_BULK_APPROVAL_PARENT_OBJECTIVE_POPUP:
    'hide_bulk_approval_parent_objective_popup',
  SEEN_GROWTH_AREA_KR_USER_GUIDE: 'SEEN_GROWTH_AREA_KR_USER_GUIDE'
};

export const TeamsInfoText = {
  labelInfoText:
    'Teams help collaborate on and review important team objectives. Add teams to objectives and review them easily.'
};

export const WeightageInfoText = {
  labelInfoText:
    "Add weightage to define relative importance for the individual's performance evaluation"
};

export const ContributorsInfoText = {
  labelInfoText: 'Only the contributors added will be able to add Key Results'
};

export const TeamActions = {
  FOLLOW: 'FOLLOW',
  UNFOLLOW: 'UNFOLLOW',
  ADD_OWNERS: 'ADD_OWNERS',
  REMOVE_OWNERS: 'REMOVE_OWNERS'
};

export const ChipViewAllOptionsSelectedCopy = {
  tags: 'No more tags to be selected. Enter a tag name to create a new one',
  hrbp: 'All HRBPs are selected'
};

export const LockObjCycleConstants = {
  unlockInfoDialogCopy1:
    'Objectives were locked on $$time$$. Clicking on proceed will allow all users to add, edit & modify objectives in this cycle.',
  unlockInfoDialogCopy2:
    'Do you want to proceed to unlock objectives for $$cycle_name$$ ?',
  lockSuccessMsg: 'Objectives for $$cycle_name$$ are now locked.',
  unlockSuccessMsg: 'Objectives for $$cycle_name$$ are now unlocked.'
};

export const DETAILS_PAGE_TABS = [
  { label: 'Check ins', value: 'CHECK_IN' },
  { label: 'Activity', value: 'ACTIVITY' }
];

export const PROFILE_PAGE_TABS = [
  { label: 'About', value: 'ABOUT' },
  { label: 'Reviews', value: 'REVIEWS' },
  { label: 'Feedback', value: 'FEEDBACK' }
];

export const PROFILE_TAB_MAP = {
  about: 'ABOUT',
  reviews: 'REVIEWS',
  feedback: 'FEEDBACK'
};

export const METRIC_TRACKING_TYPE = {
  CYCLE_TRACKED: 'CYCLE_TRACKED',
  MONTHLY_TRACKED: 'MONTHLY_TRACKED'
};

export const OBJECTIVE_VISIBILITY_TYPES = {
  public: 'PUBLIC',
  publicWithOKR: 'PUBLIC_WITH_OKR',
  protectedWithoutContributors: 'PROTECTED_WITHOUT_CONTRIBUTOR',
  protectedWithContributors: 'PROTECTED_WITH_CONTRIBUTOR',
  custom: 'CUSTOM',
  protectedWithContributorVisibleToAdmin:
    'PROTECTED_WITH_CONTRIBUTOR_VISIBLE_TO_ADMIN',
  protectedWithoutContributorVisibleToAdmin:
    'PROTECTED_WITHOUT_CONTRIBUTOR_VISIBLE_TO_ADMIN'
};

export const ObjectiveVisibilityOptionsConfig = {
  PUBLIC: {
    label: 'Public visibility',
    labelShort: 'Public',
    selectedStateIcon: 'public-visibility-blue.svg',
    key: 'public',
    icon: 'globe.svg',
    iconHover: 'globe-blue.svg'
  },
  PUBLIC_WITH_OKR: {
    label: 'Public (OKR) visibility',
    labelShort: 'Public (OKR)',
    selectedStateIcon: 'public-visibility-blue.svg',
    key: 'publicWithOKR',
    icon: 'globe.svg',
    iconHover: 'globe-blue.svg'
  },
  PROTECTED_WITHOUT_CONTRIBUTOR: {
    label: 'Protected visibility',
    labelShort: 'Protected',
    selectedStateIcon: 'protected-visibility-blue.svg',
    key: 'protectedWithoutContributors',
    icon: 'protected.svg',
    iconHover: 'protected-blue.svg'
  },
  PROTECTED_WITH_CONTRIBUTOR: {
    label: 'Protected: Contributor visibility',
    labelShort: 'Protected: Contributor',
    selectedStateIcon: 'protected-visibility-blue.svg',
    key: 'protectedWithContributors',
    icon: 'protected.svg',
    iconHover: 'protected-blue.svg'
  },
  PROTECTED_WITH_CONTRIBUTOR_VISIBLE_TO_ADMIN: {
    label: 'Protected: Contributor + Admins & HRBPs visibility',
    labelShort: 'Protected: Contributor + Admins & HRBPs',
    selectedStateIcon: 'protected-visibility-blue.svg',
    key: 'protectedWithContributorVisibleToAdmin',
    icon: 'protected.svg',
    iconHover: 'protected-blue.svg'
  },
  PROTECTED_WITHOUT_CONTRIBUTOR_VISIBLE_TO_ADMIN: {
    label: 'Protected: Admins & HRBPs visibility',
    labelShort: 'Protected: Admins & HRBPs',
    selectedStateIcon: 'protected-visibility-blue.svg',
    key: 'protectedWithoutContributorVisibleToAdmin',
    icon: 'protected.svg',
    iconHover: 'protected-blue.svg'
  },
  CUSTOM: {
    label: 'Custom visibility',
    labelShort: 'Custom',
    selectedStateIcon: 'custom-visibility-blue.svg',
    key: 'custom',
    icon: 'invite.svg',
    iconHover: 'custom-visibility-blue20.svg'
  }
};

export const CHECK_IN_PLACEHOLDER =
  "Use this place to write what went well, what didn't, what's your action plan and if any support is required for this objective";

export const ObjectiveCycleTypes = {
  EXECUTION: 'EXECUTION',
  STRATEGIC: 'STRATEGIC',
  NON_OKR: 'NON_OKR'
};

export const VisibilityFilterOptions = {
  limited: {
    label: 'View Non-Public objectives',
    labelShort: 'Limited',
    key: 'limited',
    icon: 'limited-visibility.svg',
    selectedStateIcon: 'limited-visibility-selected.svg'
  }
};

export const StarredObjectiveToggleTooltip =
  'You can star objectives you want to follow closely by clicking on the star on the left of the objective title. Use this toggle to filter starred objectives seamlessly';

export const KRFilterDisabledTooltip =
  'Please remove the level filter to apply this';

export const KrCreationDisabledTooltip =
  'You do not have permission to create a KR under this objective, you can either update the visibility of this objective to include the non okr users or reach out to your administrator to add you as an okr user';

export const MODULES = {
  ADVANCED_OKR: {
    heading: 'OKR',
    subText:
      'Selected people will have access to all the features in the OKR module',
    disclaimer: {
      inclusion:
        'Any new user that will be added as part of the selected demographics will be added to the OKR module',
      exclusion:
        'Any new user that will be added as part of the selected demographics will not get access to the OKR module'
    },
    options: [
      {
        id: 0,
        text: 'Enable for everyone',
        subText: 'Everyone in the organization will have access to this module'
      },
      {
        id: 1,
        text: 'Include specific users',
        subText: 'Only selected members will have access to this module'
      },
      {
        id: 2,
        text: 'Exclude specific users',
        subText:
          'Everyone expect selected members will get access to this module'
      }
    ]
  },
  REVIEW: {
    heading: 'Reviews',
    subText:
      'Selected people will have access to all the features in the Review module',
    disclaimer: {
      inclusion:
        'Any new user that will be added as part of the selected demographics will be added to the Review module',
      exclusion:
        'Any new user that will be added as part of the selected demographics will not get access to the Review module'
    },
    options: [
      {
        id: 0,
        text: 'Enable for everyone',
        subText: 'Everyone in the organization will have access to this module'
      },
      {
        id: 1,
        text: 'Include specific users',
        subText: 'Only selected members will have access to this module'
      },
      {
        id: 2,
        text: 'Exclude specific users',
        subText:
          'Everyone expect selected members will get access to this module'
      }
    ]
  },
  FEEDBACK: {
    heading: 'Feedback',
    subText:
      'Selected people will have access to all the features in the Feedback module',
    disclaimer: {
      inclusion:
        'Any new user that will be added as part of the selected demographics will be added to the Feedback module',
      exclusion:
        'Any new user that will be added as part of the selected demographics will not get access to the Feedback module'
    },
    options: [
      {
        id: 0,
        text: 'Enable for everyone',
        subText: 'Everyone in the organization will have access to this module'
      },
      {
        id: 1,
        text: 'Include specific users',
        subText: 'Only selected members will have access to this module'
      },
      {
        id: 2,
        text: 'Exclude specific users',
        subText:
          'Everyone expect selected members will get access to this module'
      }
    ]
  }
  // AMA: {
  //   heading: 'AMA',
  //   subText:
  //     'Selected people will have access to all the features in the AMA module',
  //  disclaimer: {
  //     inclusion:
  //       'Any new user that will be added as part of the selected demographics will be added to the AMA module',
  //     exclusion: 'Any new user that will be added as part of the selected demographics will not get access to the AMA module'
  //   },
  //   options: [
  //     {
  //       id: 0,
  //       text: 'Enable for everyone',
  //       subText: 'Everyone in the organization will have access to this module'
  //     },
  //     {
  //       id: 1,
  //       text: 'Include specific users',
  //       subText: 'Only selected members will have access to this module'
  //     },
  //     {
  //       id: 2,
  //       text: 'Exclude specific users',
  //       subText:
  //         'Everyone expect selected members will get access to this module'
  //     }
  //   ]
  // },
  // SURVEYS: {
  //   heading: 'Surveys',
  //   subText:
  //     'Selected people will have access to all the features in the Surveys module',
  //  disclaimer: {
  //     inclusion:
  //       'Any new user that will be added as part of the selected demographics will be added to the Surveys module',
  //     exclusion: 'Any new user that will be added as part of the selected demographics will not get access to the Surveys module'
  //   },
  //   options: [
  //     {
  //       id: 0,
  //       text: 'Enable for everyone',
  //       subText: 'Everyone in the organization will have access to this module'
  //     },
  //     {
  //       id: 1,
  //       text: 'Include specific users',
  //       subText: 'Only selected members will have access to this module'
  //     },
  //     {
  //       id: 2,
  //       text: 'Exclude specific users',
  //       subText:
  //         'Everyone expect selected members will get access to this module'
  //     }
  //   ]
  // }
};

export const ManagerApprovalStatus = {
  AUTO_APPROVED: 'AUTO_APPROVED',
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  DENIED: 'DENIED'
};

export const UserSubscriptionTypes = {
  ADVANCED: 'ADVANCED_OKR',
  BASIC: 'BASIC_OKR'
};

export const UserViews = {
  BASIC: 'BASIC',
  ADVANCED: 'ADVANCED',
  ADVANCED_BASIC: 'ADVANCED_BASIC'
};

export const AllAvailableRolesSuperSet = {
  'Super Administrator': {
    label: 'Super Administrator',
    role: 'SUPER_ADMIN',
    product: 'apps',
    heading:
      'This user will have access to all permissions, and can define roles for users within the organization'
  },
  Administrator: {
    label: 'Administrator',
    role: 'ADMIN',
    product: 'apps',
    heading:
      'This user can make anyone an administrator, and manage user level data'
  },
  'Goals Administrator': {
    label: 'Goals Administrator',
    role: 'ADMIN',
    product: 'okr',
    heading:
      'This user can make anyone a goals administrator, and can create company objectives, manage Objectives and define access rules for the OKR module'
  },
  'Performance Administrator': {
    label: 'Performance Administrator',
    role: 'ADMIN',
    product: 'perf',
    heading:
      'This user can make anyone a performance administrator, and can create and manage review cycles'
  },
  'Engagement Administrator': {
    label: 'Engagement Administrator',
    role: 'ADMIN', // or SUPER_ADMIN/SUPER_HR
    product: 'people',
    heading:
      'This user can make anyone an engagement administrator or a survey creator. They can create and manage org level and follow -up surveys, view participation and publish all survey reports.'
  },
  'Survey Creator': {
    label: 'Survey Creator',
    role: 'ADMIN',
    product: 'people',
    heading:
      'This user can make anyone a survey creator, and can create, manage and view participation on org level as well as follow up surveys.'
  },
  '1:1 Administrator': {
    label: '1:1 Administrator',
    role: 'ADMIN',
    product: 'communicate',
    heading:
      'This user can make anyone a 1:1 administrator, and can see analytics of the one-on-one module'
  }
};

export const AllVisibleRolesSuperSet = {
  SUPER_ADMIN: 'Super Administrator',
  ADMIN: 'Administrator',
  GOALS_ADMINISTRATOR: 'Goals Administrator',
  PERFORMANCE_ADMINISTRATOR: 'Performance Administrator',
  ENGAGEMENT_ADMINISTRATOR: 'Engagement Administrator',
  SURVEY_CREATOR: 'Survey Creator',
  ONE_ON_ONE_ADMINISTRATOR: '1:1 Administrator'
};

export const AllProducts = {
  OKR: 'okr',
  APPS: 'apps',
  PERF: 'perf',
  PEOPLE: 'people',
  COMMUNICATE: 'communicate'
};

export const TasksTabs = [
  {
    label: 'Your To-dos'
  },
  {
    label: 'Assigned by you'
  }
];

export const TasksGuide = [
  {
    illustrationImage: 'understad-okrs-illustration.svg',
    title: 'Guide to understanding OKR’s',
    description:
      'Goals are a way to measure your work, see what’s next and help your career grow. Know how to set goals for this time period.'
  },
  {
    illustrationImage: 'help-callibrate-illustration.svg',
    title: '1% better everyday',
    description:
      'Sharing feedback is one of the best ways to help celebrate wins and start important conversations about team culture.'
  }
];

export const TasksTypes = {
  OBJECTIVES: 'Objectives',
  REVIEWS: 'Reviews',
  FEEDBACK: 'Feedback',
  SURVEY: 'Survey',
  AMA: 'AMA'
};

export const EmployeeTasksReview = {
  OBJECTIVE_SELECTION: 'employee-view/objective-selection',
  PEER_SELECTION: 'employee-view/peer-selection',
  SELF_REVIEW: 'employee-view/self-review',
  PEER_REVIEW: 'employee-view/peer-review',
  FINAL_RESULTS: 'employee-view/final-results'
};

export const ManagerTasksReview = {
  TEAM_OVERVIEW: 'team-review/team-overview',
  PEER_STATUS: 'team-review/peer-status',
  OBJECTIVE_STATUS: 'team-review/objective-status'
};

export const EmploymentInformationTypes = [
  {
    title: 'Date of Joining',
    id: 'date_of_joining',
    parentId: 'user_attributes'
  },
  {
    title: 'Manager Email Id',
    id: 'email',
    parentId: 'manager'
  },
  {
    title: 'Department',
    id: 'department',
    parentId: 'user_attributes'
  },
  {
    title: 'Sub Department',
    id: 'sub_department',
    parentId: 'user_attributes'
  },
  {
    title: 'Designation',
    id: 'designation',
    parentId: 'user_attributes'
  },
  {
    title: 'Location',
    id: 'location',
    parentId: 'user_attributes'
  }
];

export const ObjectiveProgressIntegrationStatus = {
  enabled: 'enabled',
  disabled: 'disabled',
  integrated: 'integrated'
};

export const OkrModuleDataDependentPaths = [
  'objectives',
  'userboard',
  'settings',
  'okr-reports'
];

export const ObjectiveTypes = {
  company: 'COMPANY',
  nonAligned: 'NON_ALIGNED'
};

export const SentryApiErrorWhitelist = [
  "You don't have access to this objective",
  'User not permitted to do this operation',
  'Objective doesn’t exist'
];

export const SentryWhitelist = [
  'Request failed with status code 404',
  'service_worker',
  'Not logged in',
  'Session revalidation failure',
  'httpclient_reauthenticate_renew_credentials_error',
  'An error has occurred. Please try again after some time',
  'Transaction timed out due to inactivity',
  "Cannot read properties of null (reading 'contentWindow')",
  'network error',
  'NetworkError when attempting to fetch resource',
  'The network connection was lost.',
  'Session expired. Revalidating...',
  'Load failed',
  'Non-Error promise rejection captured with keys: code, message, name',
  'Sorry, you don’t have required access',
  'Unauthorized',
  'This objective was updated recently. Please refresh',
  'Remote Config'
];

export const DefaultObjectivesCount = 40;

export const ConfigCacheKeys = {
  goalsStrengthSchema: 'goalsStrengthSchema',
  customRangeRecentSelection: 'customRangeRecentSelection'
};

export const AppConfigStorageKeys = {
  objectStoreIdentifier: 'people_cues_common',
  goals_feature_config: '10xgoals_feature_config',
  people_feature_config: '10xpeople_feature_config',
  cues_feature_config: '10xcues_feature_config',
  goals_http_client_config: '10xgoals_httpclient_config',
  people_http_client_config: '10xpeople_httpclient_config',
  reviews_http_client_config: 'reviews_httpclient_config',
  whats_new_config: 'whats_new_config',
  peoplecues_redirects_config: 'peoplecues_redirects_config'
};

export const CheckInHoverViewEventName = 'set_check_in_hover_view_details';
export const IDPCheckInHoverViewEventName =
  'set_idp_check_in_hover_view_details';
export const AutoRollUpDialogEventName = 'auto_roll_up_dialog';

export const HrisIntegrationStatus = {
  active: 'ACTIVE',
  inactive: 'INACTIVE'
};

export const RequestTypeByPathIdentifier = {
  hasObjectivesPath: url => url?.indexOf('v1/objective') > -1 || false,
  isFetchMyObjectivesView: url =>
    (RequestTypeByPathIdentifier.hasObjectivesPath(url) &&
      url?.indexOf('/filter/v2') === -1 &&
      url?.indexOf('/advanced-filter') === -1 &&
      url?.indexOf('/user-view') === -1 &&
      url?.indexOf('user_id=') > -1) ||
    false,
  isFetchAllObjectivesView: url =>
    (RequestTypeByPathIdentifier.hasObjectivesPath(url) &&
      url?.indexOf('user_id=') === -1 &&
      url?.indexOf('/filter/v2') === -1 &&
      url?.indexOf('/advanced-filter') === -1 &&
      url?.indexOf('/user-view') === -1 &&
      url?.indexOf('objective_type=') > -1) ||
    false,
  any: url =>
    RequestTypeByPathIdentifier.isFetchMyObjectivesView(url) ||
    RequestTypeByPathIdentifier.isFetchAllObjectivesView(url)
};

export const OwnerAssignmentErrors = {
  publicOkr: 'You cannot assign a Public (OKR) objective to a Non-OKR user',
  boundedOkr:
    'You cannot assign an objective created in OKR cycle to a Non-OKR user'
};

export const OrgSubscribableModules = [
  'SURVEY',
  'AMA',
  'BASIC_OKR',
  'ADVANCED_OKR',
  'REVIEW',
  'FEEDBACK'
];

export const ModuleNames = {
  SURVEY: 'SURVEY',
  AMA: 'AMA',
  BASIC_OKR: 'BASIC_OKR',
  ADVANCED_OKR: 'ADVANCED_OKR',
  REVIEW: 'REVIEW',
  FEEDBACK: 'FEEDBACK',
  RECOGNITION: 'RECOGNITION',
  GROWTH_PLAN: 'GROWTH_PLAN',
  ONE_ON_ONE: 'ONE_ON_ONE'
};

export const PaidModules = {
  SURVEY: 'SURVEY',
  ADVANCED_OKR: 'ADVANCED_OKR',
  REVIEW: 'REVIEW'
};

export const CrossSellDialogContent = {
  CROSSSELL: {
    title: 'Start the journey of building a People-First culture',
    peopleOnlyCardTitle: 'Start building a People First Culture',
    perfOnlyCardTitle: 'Start building an Ambitious Culture',
    okrOnlyCardTitle: 'Start building a High Performing Culture',
    ADVANCED_OKR_CONTENT: {
      image: '/assets/images/okr-logo-crossell.svg',
      title: 'Objectives & Key Results',
      subtitle:
        "Get a bird's eye view of your organisation's goals & align teams",
      pointers: [
        'Objectives and goal tracking',
        'Objectives tree with infinite cascade',
        'Governance analytics & dashboards'
      ],
      learnMoreLink:
        'https://www.xto10x.com/peoplecues/objectives-and-key-results'
    },
    ADVANCED_OKR_ONLY_CONTENT: {
      image: '/assets/images/okr-logo-crossell.svg',
      title: 'Objectives & Key Results',
      subtitle:
        'Execute strategy by establishing team goals, objective owners and measurable results',
      pointers: [
        'Objectives and goal tracking',
        'Governance analytics & dashboards',
        'Powerful integrations'
      ],
      learnMoreLink:
        'https://www.xto10x.com/peoplecues/objectives-and-key-results'
    },
    REVIEW_CONTENT: {
      image: '/assets/images/review-logo-crossell.svg',
      title: 'Performance Management',
      subtitle: 'Enable people to become their best selves and outperform',
      pointers: [
        'Configurable reviews across frameworks',
        '360˚ continuous feedback',
        'Performance reporting and analytics'
      ],
      learnMoreLink: 'https://www.xto10x.com/peoplecues/performance-management'
    },
    REVIEW_ONLY_CONTENT: {
      image: '/assets/images/review-logo-crossell.svg',
      title: 'Performance Management',
      subtitle:
        'Do fair performance reviews  to solicit both org  and individual growth',
      pointers: [
        'Fully configurable Reviews across',
        '360˚ continuous feedback',
        'Individual performance reporting and analytics'
      ],
      learnMoreLink: 'https://www.xto10x.com/peoplecues/performance-management'
    },
    SURVEY_CONTENT: {
      image: '/assets/images/surveys-logo-crossell.svg',
      title: 'Employee Engagement',
      subtitle: "Measure and continuously improve your org's health",
      pointers: [
        'eNPS diagnosis',
        'Continuous surveys',
        'Ecosystem benchmarking'
      ],
      learnMoreLink: 'https://www.xto10x.com/peoplecues/employee-engagement'
    },
    SURVEY_ONLY_CONTENT: {
      image: '/assets/images/surveys-logo-crossell.svg',
      title: 'Employee Engagement',
      subtitle:
        'Improve employees experience through regular check-ins and timely interventions',
      pointers: [
        'eNPS diagnosis with benchmarks',
        'Continuous surveys (30-60-90 days, work-anniversary, etc)',
        'Expert led people excellence services'
      ],
      learnMoreLink: 'https://www.xto10x.com/peoplecues/employee-engagement'
    }
  },
  SEL: {
    title: 'Start building a People First culture',
    subtitle:
      'Build a predictable performance path and a strong governance culture.',
    SURVEY_CONTENT: {
      image: '/assets/images/surveys-logo-crossell.svg',
      title: 'Employee Engagement',
      subtitle:
        'Improve employees experience through regular check-ins and timely interventions',
      pointers: [
        'eNPS diagnosis with benchmarks',
        'Continuous surveys (30-60-90 days, work-anniversary, etc)',
        'Expert led people excellence services'
      ],
      learnMoreLink: 'https://www.xto10x.com/peoplecues/employee-engagement'
    }
  }
};

export const ActivityFilters = [
  {
    name: 'All',
    id: 'all',
    filterType: 'all'
  },
  {
    name: 'Action items',
    id: 'action_item',
    filterType: 'action_item',
    image: '/assets/images/action-items/actionItem_grey.svg',
    activeImage: '/assets/images/action-items/actionItem_blue.svg'
  },
  {
    name: 'Comments',
    id: 'comments',
    filterType: ActivityType.OBJECTIVE_COMMENT,
    image: '/assets/images/activityComment.svg',
    activeImage: '/assets/images/activityComment_blue.svg'
  }
];

export const HrbpHelpLinks = {
  why:
    'https://docs.xto10x.com/peoplecues/settings/invite-users/roles-and-permissions/assgin-roles/assigning-hrbps#why-can-i-not-assign-hrbp-to-founder-s'
};

export const VisibilityInfoTypeDescription = {
  [OBJECTIVE_VISIBILITY_TYPES.public]:
    'Visible to you, users having OKR module access in the organisation, last assigner & parent owner.',
  [OBJECTIVE_VISIBILITY_TYPES.publicWithOKR]:
    'Visible to you, users having OKR module access in the organisation, last assigner & parent owner.',
  [OBJECTIVE_VISIBILITY_TYPES.protectedWithContributors]:
    'Visible to you, line managers, last assigner , parent owner & contributors',
  [OBJECTIVE_VISIBILITY_TYPES.protectedWithoutContributors]:
    'Visible to you, line managers, last assigner & parent owner.',
  [OBJECTIVE_VISIBILITY_TYPES.protectedWithContributorVisibleToAdmin]:
    'Visible to you, line managers, last assigner,goals administrators, parent owner & contributors.',
  [OBJECTIVE_VISIBILITY_TYPES.protectedWithoutContributorVisibleToAdmin]:
    'Visible to you, line managers, last assigner, goals administrators & parent owner',
  [OBJECTIVE_VISIBILITY_TYPES.custom]:
    "This objective will be visible to the you and individuals you specify. Select people who have worked on this objective and want to have visibility for the additional reviewers' review. Manager will have the visibility by default."
};

export const DeepLinkAppliedFilterParams = ['dp'];

export const DeeplinFilterParamTextMap = {
  dp: 'Department'
};
export const BULK_MANAGER_APPROVAL_MODAL_TYPES = {
  approveObjectiveWithKrs: 'bulk_approve_objective_with_krs',
  approveOnlyParentObjective: 'bulk_approve_only_parent_objective',
  approveAllObjectives: 'bulk_approve_all_objectives'
};

export const BulkManagerApprovalModalData = {
  [BULK_MANAGER_APPROVAL_MODAL_TYPES.approveObjectiveWithKrs]: {
    title: 'Approve $$no_of_krs$$ Key Results along with this Objective?',
    description:
      'By approving this objective, all Key Results owned by your direct reportees will also be approved. Do you want to confirm the approval?',
    mainImageSrc: '/assets/images/bulk-manager-approval/objectiveWithKrs.svg',
    configKey: UserConfigType.HIDE_BULK_APPROVAL_OKR_AND_KRS_POPUP
  },
  [BULK_MANAGER_APPROVAL_MODAL_TYPES.approveOnlyParentObjective]: {
    title: 'Approve the parent Objective only?',
    description:
      'By approving this objective, you are only approving the parent objective and not the Key Results that fall under it. If you intended to approve the Key Results as well, please go back and click on dropdown besides “Approve” and “Approve Objective with Key Results”.',
    mainImageSrc:
      '/assets/images/bulk-manager-approval/onlyParentObjectives.svg',
    configKey: UserConfigType.HIDE_BULK_APPROVAL_PARENT_OBJECTIVE_POPUP
  },
  [BULK_MANAGER_APPROVAL_MODAL_TYPES.approveAllObjectives]: {
    title: 'Approve all $$no_of_krs$$ Objectives along with their Key Results?',
    description:
      'By approving all objectives, all Key Results owned by your direct reportees will also be approved.',
    mainImageSrc:
      '/assets/images/bulk-manager-approval/approveAllObjectives.svg',
    configKey: UserConfigType.HIDE_BULK_APPROVAL_ALL_OBJECTIVES_POPUP
  }
};

export const maximumFilterLength = 20;

export const ExportChoiceOptions = [
  {
    id: 0,
    title: 'Export current view',
    subtitle: 'selected preset tabs, filters and search results'
  },
  {
    id: 1,
    title: 'All Objectives',
    subtitle: 'all objectives and their key results will be exported'
  }
];

export const CheckinHoverTabs = [
  {
    id: 0,
    text: 'Check-ins',
    showCount: false,
    image: '/assets/images/action-items/checkedIn.svg',
    activeImage: '/assets/images/action-items/checkedIn_blue.svg'
  },
  {
    id: 1,
    text: 'Action Items',
    showCount: true,
    key: 'pending_action_items_count',
    image: '/assets/images/action-items/actionItem_grey.svg',
    activeImage: '/assets/images/action-items/actionItem_blue.svg'
  }
];

export const DataSharingIntegrationsMap = {
  AI_ASSIST: {
    name: 'AI assist',
    description:
      '- PeopleCues AI can extract key points in a high-level summary. By leveraging AI technology, we can make data-informed decisions and create more impactful objectives.',
    configName: FirebaseKeys.objective_suggestion_AI,
    imageName: '/assets/images/AIAssist.svg',
    supportTicketQueryStatement: 'Disable AI assist to create objectives'
  }
};

export const ObjectiveBulUploadConstants = {
  dataLimit: 5000000,
  errorMessage: 'The uploaded file is greater than the supported limit of 5MB'
};

export const AsyncBulkInviteConstants = {
  IN_PROGRESS_STATUS: 'IN_PROGRESS',
  DISABLED_TOOLTIP_TEXT:
    'Invite user through excel file upload is currently in progress. Please try again after few minutes.',
  API_CALL_FETCHING_TEXT: 'Loading....',
  MEMBERS_PAGE_INDICATOR_TEXT:
    'Org hierarchy update in progress. Refrain from updating details'
};

export const SUPPORT_EMAIL = 'support-cues@xto10x.com';

export const ContinuousSurveySubCategoryType = {
  ONBOARDING: 'ONBOARDING',
  PULSE: 'PULSE',
  ANNUAL: 'ANNUAL'
};

export const UserPersonas = {
  ADMIN: 'Admin',
  HRBP: 'HRBP',
  LEADER: 'Leader',
  MANAGER: 'Manager',
  USER: 'User'
};

export const ActivityAttributesConstants = {
  SYSTEM: 'SYSTEM',
  BULK_OBJECTIVE_SYNC: 'BULK_OBJECTIVE_SYNC'
};

export const HRIS_DISABLED_TOOLTIP_TEXT =
  'HRIS sync is enabled for user data management';

export const AnalyticsDefaultOptions = {
  ga4: {
    enable: true,
    debug: false
  },
  mixpanel: {
    enable: true,
    debug: false,
    blacklist: [
      {
        type: 'action',
        constant_value: [
          'api_error',
          'get_org_subscription_worker',
          'idb_cache_install',
          'service worker registration succeeded',
          'event stream connection',
          'idb_cache_hit'
        ],
        regex_value: []
      }
    ]
  },
  sentry: {
    enable: true,
    debug: false
  }
};
